module.exports = __webpack_public_path__ + "media/images/ajax-loader-25e15574.gif";